module.exports = __webpack_public_path__ + "static/img/insurance-product-12.dbe3067.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/insurance-product-12.png
// module id = jr5C
// module chunks = 4